<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Communications</template>
        </page-header>
        <div class="lg:px-6 px-4 pt-2 flex items-center space-x-2 text-sm">
            <p>Remaining Credits:</p>
            <Spinner
                v-if="loadingCredits"
                :full-screen="false"
                :inline="true"
                width="16px"
                height="16px"
            />
            <p v-else>{{ Math.round(credits) }}</p>
        </div>
        <pro-table
            :resource="resource"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="created_at"
            direction="DESC"
            delete-label="title"
            :actions="actions"
            :permissions="true"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';
    import axios from "axios";

    export default {
        name: "Members",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'communications',
                numberOfFilters: 1,
                pageActions: {},
                fields: [
                    {
                        name: 'Subject',
                        column: 'subject',
                        sortCol: 'subject'
                    },
                    {
                        name: 'Sent',
                        column: 'sent',
                        sortCol: 'sent_at',
                        date: true,
                        columnClass: 'whitespace-no-wrap',
                        format: 'DD/MM/YYYY  h:mm a'
                    },
                    {
                        name: 'Sent By',
                        column: 'sent_by',

                    },
                    {
                        name: 'Sent To',
                        column: 'sent_to',
                        align: 'center'
                    },
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'communications.show', display: {key: 'sent_at', isset: true} },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'communications.edit', display: {key: 'sent_at', isset: false} },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'communications.destroy', display: {key: 'sent_at', isset: false} },
                    ]
                },
                credits: null,
                loadingCredits: true,
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Communication',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/communications/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('communications.create') !== -1
                    }
                ],
                additional: []
            }

            axios.get(process.env.VUE_APP_API_URL + '/sms-credits')
                .then(response => {
                    this.credits = response.data.data.credits
                    this.loadingCredits = false
                })
        },
        computed: {
            searchValue () {
                const filters = this.$store.getters.filters;

                if (filters.news.search){
                    return filters.news.search.value;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
